<template>
  <div class="license-plate-container">
    <!-- 车牌显示与输入区域 -->
    <div class="plate-show">
      <div
        v-for="(item, index) in plateArr"
        :key="index"
        class="plate-item"
        :class="{ active: currentIndex === index }"
        @click="handlePlateItemClick(index)"
      >
        {{ item || (index === 0 ? "陕" : index === 1 ? "A" : "-") }}
      </div>
    </div>
    <!-- 省份选择键盘 -->
    <div class="keyboard" v-show="showProvinceKeyboard">
      <div class="keyboard-title">
        <span>请选择省份</span>
        <button @click="hideProvinceKeyboard">取消</button>
      </div>
      <div class="keyboard-keys">
        <div
          v-for="(province, pIndex) in provinces"
          :key="'province_' + pIndex"
          class="keyboard-key"
          @click="selectProvince(province)"
        >
          {{ province }}
        </div>
      </div>
      <div class="keyboard-footer">
        <button @click="confirmProvince">确定</button>
      </div>
    </div>

    <!-- 字符输入键盘 -->
    <div class="keyboard" v-show="showCharKeyboard">
      <div class="keyboard-title">
        <span>{{ currentIndex === 1 ? "请输入字母" : "请输入数字" }}</span>
        <button @click="deleteChar">删除</button>
      </div>
      <div class="keyboard-keys">
        <div
          v-for="(char, cIndex) in chars"
          :key="'char_' + cIndex"
          class="keyboard-key"
          @click="inputChar(char)"
        >
          {{ char }}
        </div>
      </div>
      <div class="keyboard-footer">
        <button @click="confirmInput">完成</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LicensePlateInput",
  props: {
    cartype: {
      // type: String, // 指定类型
      required: true, // 是否必传
      default: "sedan", // 默认值
    },
    car: {
      // type: Object, // 指定类型
    },
  },
  data() {
    return {
      // 车牌字符数组
      plateArr: ["陕", "A", "", "", "", "", ""],
      // 当前选中的输入位置索引
      currentIndex: 0,
      // 省份数据
      provinces: [
        "京",
        "津",
        "沪",
        "渝",
        "冀",
        "豫",
        "云",
        "辽",
        "黑",
        "湘",
        "皖",
        "鲁",
        "新",
        "苏",
        "浙",
        "赣",
        "鄂",
        "桂",
        "甘",
        "晋",
        "蒙",
        "陕",
        "吉",
        "闽",
        "贵",
        "粤",
        "青",
        "藏",
        "川",
        "宁",
        "琼",
        "使",
        "无",
      ],
      // 字符数据（字母 + 数字）
      chars: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "J",
        "K",
        "L",
        "M",
        "N",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "港",
        "澳",
        "挂",
        "学",
      ],
      // 是否显示省份选择键盘
      showProvinceKeyboard: false,
      // 是否显示字符输入键盘
      showCharKeyboard: false,
      cartypes: 1,
    };
  },
  watch: {
    cartype(newVal) {
      console.log(newVal);
      this.cartypes = newVal;
      this.plateArr =
        newVal == 1
          ? ["陕", "A", "", "", "", "", ""]
          : ["陕", "A", "", "", "", "", "", ""];
    },
    car(newVal) {
      if (newVal == 1 || newVal == 2) {
        this.plateArr =
          newVal == 1
            ? ["陕", "A", "", "", "", "", ""]
            : ["陕", "A", "", "", "", "", "", ""];
      } else {
        const num = newVal.split("");
        this.plateArr = num;
      }
    },
  },
  methods: {
    // 点击车牌输入项
    handlePlateItemClick(index) {
      this.currentIndex = index;
      if (index === 0) {
        this.showProvinceKeyboard = true;
        this.showCharKeyboard = false;
      } else {
        this.showProvinceKeyboard = false;
        this.showCharKeyboard = true;
      }
    },

    // 选择省份
    selectProvince(province) {
      this.plateArr[0] = province;
      this.showProvinceKeyboard = false;
      this.currentIndex = 1;
      this.showCharKeyboard = true;
    },

    // 确认省份选择
    confirmProvince() {
      if (this.plateArr[0]) {
        this.showProvinceKeyboard = false;
        this.currentIndex = 1;
        this.showCharKeyboard = true;
      }
    },

    // 隐藏省份键盘
    hideProvinceKeyboard() {
      this.showProvinceKeyboard = false;
    },

    // 输入字符
    inputChar(char) {
      // 根据当前位置限制输入类型
      if (this.currentIndex === 1 && /\d/.test(char)) {
        // 第二位必须是字母
        return;
      }
      if (this.currentIndex < 8) {
        this.plateArr[this.currentIndex] = char;
        if (this.currentIndex == 6 && this.cartypes == 1) {
          this.showCharKeyboard = false;
          this.addToHistory();
        }
        // 自动移动到下一个位置
        if (this.currentIndex < 7) {
          this.currentIndex++;
        } else {
          this.showCharKeyboard = false;
          this.addToHistory();
        }
      }
    },

    // 删除字符
    deleteChar() {
      if (this.currentIndex > 0) {
        this.plateArr[this.currentIndex] = "";
        this.currentIndex--;

        // 如果退回到第一位，显示省份键盘
        if (this.currentIndex === 0) {
          this.showCharKeyboard = false;
          this.showProvinceKeyboard = true;
        }
      }
    },

    // 确认输入完成
    confirmInput() {
      this.showCharKeyboard = false;
      this.addToHistory();
    },

    // 添加
    addToHistory() {
      const plate = this.plateArr.join("");
      this.$emit("child-event", plate);
    },
  },
};
</script>

<style scoped>
.license-plate-container {
  width: 100%;
  /* max-width: 500px; */
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.plate-show {
  display: flex;
  justify-content: space-around;
  /* border: 1px solid #ccc; */
  /* border-radius: 5px; */
  overflow: hidden;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.plate-item {
  /* flex: 1; */
  width: 10%;
  text-align: center;
  height: 50px;
  line-height: 50px;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  font-size: 20px;
  cursor: pointer;
  transition: background-color 0.2s;
  /* margin-right: 10px; */
}

.plate-item:last-child {
  /* border-right: none; */
}

.plate-item.active {
  background-color: #e6f7ff;
}

.history-search {
  margin-bottom: 20px;
}

.history-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

.history-tags {
  display: flex;
  flex-wrap: wrap;
}

.history-tag {
  padding: 6px 12px;
  background-color: #f2f2f2;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.history-tag:hover {
  background-color: #e6e6e6;
}

.keyboard {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  border-top: 1px solid #ddd;
  padding: 15px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
  transition: transform 0.3s;
  transform: translateY(0);
}

.keyboard-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.keyboard-title span {
  font-size: 16px;
  font-weight: bold;
}

.keyboard-title button,
.keyboard-footer button {
  padding: 8px 15px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.keyboard-title button {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #ddd;
}

.keyboard-title button:hover {
  background-color: #e2e6ea;
}

.keyboard-footer button:hover {
  background-color: #0069d9;
}

.keyboard-keys {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  margin-bottom: 15px;
}

.keyboard-key {
  height: 45px;
  line-height: 45px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #f8f8f8;
  font-size: 18px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.keyboard-key:hover {
  background-color: #e9e9e9;
}

.keyboard-footer {
  text-align: center;
}
</style>

    